import Swiper from 'swiper';
import SwiperCore, {
  A11y,
  Keyboard,
  Navigation,
  Pagination,
} from 'swiper/core';
import { Component } from '../../componentSystem/component';
import { ImageGalleryComponentConfig } from './imageGalleryComponentConfig';

SwiperCore.use([A11y, Keyboard, Navigation, Pagination]);

export class ImageGalleryComponent extends Component {
  protected readonly config: ImageGalleryComponentConfig =
    new ImageGalleryComponentConfig();

  private onSwiperInit(swiper: Swiper): void {
    const { animateClass } = ImageGalleryComponentConfig;

    swiper.$el.addClass(animateClass);

    this.setActiveImageHeight(swiper);
  }

  private onSwiperActiveIndexChange(swiper: Swiper): void {
    this.setActiveImageHeight(swiper);
    if (!swiper.pagination.bullets) {
      return;
    }

    const { paginationBulletPreviouslyActiveClass } =
      ImageGalleryComponentConfig;
    const { previousIndex } = swiper;

    // @ts-ignore
    swiper.pagination.bullets.forEach((bullet: HTMLElement, index) => {
      if (index === previousIndex) {
        bullet.classList.add(paginationBulletPreviouslyActiveClass);
      } else {
        bullet.classList.remove(paginationBulletPreviouslyActiveClass);
      }
    });
  }

  private setupSwiper() {
    const { swiperOptions } = ImageGalleryComponentConfig;

    const swiperElement = this.containerElement.querySelector(
      '[data-js-swiper]'
    ) as HTMLElement;

    swiperOptions.on = {
      init: this.onSwiperInit.bind(this),
      activeIndexChange: this.onSwiperActiveIndexChange.bind(this),
    };

    const swiperInstance = new Swiper(swiperElement, swiperOptions);

    window.addEventListener('resize', () => {
      this.setActiveImageHeight(swiperInstance);
    });
  }

  private setActiveImageHeight(swiper: Swiper) {
    const { slides, realIndex } = swiper;
    const activeImageElement = slides[realIndex].querySelector(
      'img'
    ) as HTMLImageElement;

    if (activeImageElement) {
      this.containerElement.style.setProperty(
        '--active-image-height',
        `${activeImageElement.height / 10}rem`
      );
    } else {
      this.containerElement.style.removeProperty('--active-image-height');
    }
  }

  public init() {
    window.addEventListener('load', this.setupSwiper.bind(this));
  }
}
